import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "triangle.icon",
  "use": "triangle.icon-usage",
  "viewBox": "1859.012 -10938.489 22.422 19.934",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"1859.012 -10938.489 22.422 19.934\" id=\"triangle.icon\"><path data-name=\"Union 58\" d=\"M0,11.251H19.933L0,22.422Zm0,0V0L19.933,11.251Z\" transform=\"rotate(-90 -4529.772 -6388.784)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/triangle.icon.svg
// module id = JWkH
// module chunks = 13